const jsonld = {
  $elScriptJsonLd: null,
  data: {
    '@context': 'http://schema.org/',
    '@type': 'Product',
    name: '',
    image: [''],
    description: '',
    brand: {
      '@type': '',
      name: '',
    },
  },
  append: function (jsonLd) {
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.text = JSON.stringify(jsonLd);

    if (!this.$elScriptJsonLd) {
      document.querySelector('body').appendChild(el);
    } else {
      this.$elScriptJsonLd.text = JSON.stringify(jsonLd);
    }

    if (!this.$elScriptJsonLd) {
      this.$elScriptJsonLd = el;
    }
  },
  remove: function () {
    if (this.$elScriptJsonLd) {
      this.$elScriptJsonLd.remove();
      this.$elScriptJsonLd = null;
    }
  },
  setData: function (newData) {
    this.data = Object.assign({}, this.data, newData);
  },
};

export default jsonld;
